module.exports = __webpack_public_path__ + "static/kalusova-051a3e10038146c5cd2b0f988bc1c843.jpg";